// Portions of this file are Copyright 2021 Google LLC, and licensed under GPL2+. See COPYING.
export const zipArchives = {
    'fonts': {},
    'grafik': {
        description: 'Grafik press models',
    },
    'lap-desk': {
        description: 'Lap desk models',
    },
};
export const deployedArchiveNames = Object.entries(zipArchives)
    .filter(([_, { deployed }]) => deployed == null || deployed)
    .map(([n]) => n);
